import AuthSubmit from "components/v2/Auth/AuthSubmit";
import RegistrationFields from "./RegistrationFields";
import RegistrationTerms from "./RegistrationTerms";
import useRegisterInstitution from "api/UserResource/useRegisterInstitution";
import { Form, Formik } from "formik";
import { MAX_IMAGE_SIZE, phoneRegex } from "utils";
import * as Yup from "yup";
import { useRef, useState } from "react";
import useGetProvinces from "api/Province/useGetProvinces";

const Institution = () => {
	const [captchaValue, setCaptchaValue] = useState("");
	const recaptchaRef = useRef(null);


	const { data: provinces, isLoading: isLoadingProvinces } = useGetProvinces();

	// console.log({ provinces });

	const initialValues = {
		email: "",
		username: "",
		password: "",
		first_name: "",
		last_name: "",
		sex: "",
		mobile_number: "",
		password_confirmation: "",
		name: "",
		type: "School",
		level: "",
		country: "Zimbabwe",
		province: "",
		number_of_users: "",
		like_notifications: false,
		terms: false,
		avatar: null,
		role: "Institution",
	};

	const registerSchema = Yup.object().shape({
		username: Yup.string().required("Username is required"),
		email: Yup.string().required("Email is required").email("Invalid email address"),
		terms: Yup.boolean().isTrue("Verify that you have read the terms and conditions"),
		mobile_number: Yup.string()
			.required("Mobile number required")
			.matches(phoneRegex, "Invalid phone number")
			.min(10, "Mobile number must have at least characters")
			.max(20, "Mobile number cannot exceed 20 characters"),
		password: Yup.string()
			.min(6, "At least 6 characters required")
			.matches(/[a-zA-Z]/, "Must have at least one alphabet character")
			.matches(/[0-9]/, "Must have at least one digit")
			.required("Password required"),
		password_confirmation: Yup.string()
			.oneOf([Yup.ref("password")], "Passwords didn't match")
			.required("Confirmation required"),
		first_name: Yup.string().required("First name is required"),
		last_name: Yup.string().required("Last name is required"),
		name: Yup.string().required("Name of institution is required"),
		level: Yup.string().required("Level of institution is required"),
		country: Yup.string().required("Provide country where institution is located"),
		province: Yup.string().when("country", {
			is: (country) => country === "Zimbabwe",
			then: Yup.string().required("Province is required"),
		}),
		avatar: Yup.mixed()
			.nullable()
			.test("fileSize", `Image size should not exceed ${MAX_IMAGE_SIZE}MB`, (value) => {
				if (!value) return true;
				return value.size / 1024 / 1024 <= MAX_IMAGE_SIZE;
			}),
	});

	const { mutateAsync, isLoading } = useRegisterInstitution();
	const handleRegister = async (data) => {
		try {
			await mutateAsync({
				...data,
				type: "School",
				like_notifications: data.like_notifications ? 1 : 0,
				captcha: captchaValue,
				client: "web",
			});
		} catch (error) {
			if (recaptchaRef.current) recaptchaRef.current.reset();
			setCaptchaValue(""); // Clear captcha value
			// console.error("Registration failed:", error);
		}
	};

	return (
		<>

			<Formik initialValues={initialValues} onSubmit={handleRegister} validationSchema={registerSchema}>
				<Form className="auth-registration" noValidate>
					<RegistrationFields institution provinces={provinces || []} isLoadingProvinces={isLoadingProvinces} />
					<RegistrationTerms />
					<AuthSubmit
						captchaRef={recaptchaRef}
						captchaValue={captchaValue}
						onCaptchaChange={(value) => setCaptchaValue(value || "")}
						isLoading={isLoading}
						label="Create account"
						loadingLabel="Creating your account…"
					/>
				</Form>
			</Formik>
		</>
	);
};

export default Institution;
